import { CurrencyEnum, type Transaction, TransactionTypeEnum } from "@finway-group/shared/lib/models"
import { isSet } from "@finway-group/shared/lib/utils/common"

export const isTransactionArchived = (transaction: Pick<Transaction, "isArchived">) => transaction.isArchived

export const isTransactionManuallyUnarchived = (transaction: Pick<Transaction, "isAutoArchiveOff">) => transaction.isAutoArchiveOff

export const getVendorIdsFromTransactions = (transactions: Array<Transaction>) => transactions.map((transaction) => transaction.transactionData.vendor).filter((vendor) => vendor)

export const getSourceCurrency = (transaction: Transaction) => {
    try {
        if (transaction.transactionType === TransactionTypeEnum.CSV_TRANSACTION) {
            return transaction.transactionData?.currency ?? CurrencyEnum.EUR
        }
        const rawContent = JSON.parse(`${(transaction as any).sourceRawContent}`)
        const isPaypalTransaction = isSet(rawContent.paypalData)
        return isPaypalTransaction ? rawContent.currency : rawContent.sourceCurrency
    } catch (error) {
        return undefined
    }
}

export const getTransactionDetailsSourceCurrency = (transaction: Transaction, expenseCurrency?: CurrencyEnum): CurrencyEnum | undefined => {
    const sourceCurrencyFromRawContent = getSourceCurrency(transaction)
    return sourceCurrencyFromRawContent && transaction.transactionData?.currency !== sourceCurrencyFromRawContent ? sourceCurrencyFromRawContent : expenseCurrency
}
